import { render, staticRenderFns } from "./healthscreen-confirmation.vue?vue&type=template&id=66eab720&scoped=true&"
import script from "./healthscreen-confirmation.vue?vue&type=script&lang=ts&"
export * from "./healthscreen-confirmation.vue?vue&type=script&lang=ts&"
import style0 from "./healthscreen-confirmation.vue?vue&type=style&index=0&id=66eab720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eab720",
  null
  
)

export default component.exports